
/**
 * Parametros requeridos
 * action: 0: ELIMINAR 1: NUEVO 2: EDITAR 3: VER
 * dataProfile: object
 * dialogProfile: true || false
 */

import { defineComponent, ref, inject } from 'vue'
//compoenents
import swPerson from "./steps/swPerson.vue"
import PhotoManager from "@/views/persons/photo/PhotoManager.vue";
import sFiles from "@/components/wizard/steps/sFiles.vue"
import Anotations from "@/components/widgets/mixed/Anotations.vue"
import LineTime from "@/components/widgets/mixed/LineTime.vue"
import { actions } from "@/core/data/shared";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    props: {
        status: {
            type: null,
            required: true,
            default: []
        }
    },
    components: { swPerson, PhotoManager, sFiles, Anotations, LineTime },
    emits: ['onResponseMdPerfil'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const gblAccount = inject<any>('gblAccount')
        const ta = ref(process.env.VUE_APP_TA)
        const listActions = actions
        const action = inject<any>('action')
        const dataProfile = inject<any>('dataProfile')
        const dialogProfile = inject<any>('dialogProfile')
        const altura = screen.height - 200;
        const activeTab = ref('tab1')
        const disabled = ref()

        const onOpen = () => {
            disabled.value = (action.value == 1) ? true : false
        }

        const onOpened = () => {
            activeTab.value = 'tab1'
        }

        const onClosed = () => {
            activeTab.value = 'tabX'
            emit("onResponseMdPerfil", "")
        }

        //metodo del forumlario 1: persona
        const onResponse = (data) => {
            if (data.status == 'success') {
                disabled.value = false;
                dataProfile.value = data.payroll
                action.value = 2;
                //dataProfile.value.payroll = data.payroll;
                //dataProfile.value.message = data.message;
                //dataProfile.value.persona = data.persona;
            }
        }

        return {
            t,
            ta,
            gblAccount,
            action,
            dialogProfile,
            dataProfile,
            listActions,
            altura,
            activeTab,
            disabled,
            //methods
            onOpen,
            onOpened,
            onClosed,
            onResponse
        }
    },
})
